export const checkEndUrlConfig = (url) => {
    return url[url.length - 1] === "/" ? url : `${url}/`;
};
